import { DealerConsoleAction, FlagStateType, GameType } from './app-enums.model';
import { ChatMessageEvent } from './app-events.model';
import { Json } from '../types.model';

export enum DealerRequestType {
    DealerAction = 'dealer-action',
    GetChatMessages = 'get-chat-messages',
    SetFlagState = 'set-flag-state',
    GetAvailableGames = 'get-available-games',
    ChangeGame = 'change-game'
}

export interface DealerActionRequestMessage extends Json {
    action: DealerConsoleAction;
}

export interface SetFlagStateRequestMessage extends Json {
    flag: FlagStateType;
    state: boolean;
}

export interface ChangeGameRequestMessage extends Json {
    game: GameType;
}

export interface GetChatMessagesResponseMessage extends Json {
    messages: ChatMessageEvent[];
}

export interface GetGamesResponseMessage extends Json {
    games: GameType[];
}
